import { render, staticRenderFns } from "./KolRenewal.vue?vue&type=template&id=572f14ef&scoped=true"
import script from "./KolRenewal.vue?vue&type=script&lang=js"
export * from "./KolRenewal.vue?vue&type=script&lang=js"
import style0 from "./KolRenewal.vue?vue&type=style&index=0&id=572f14ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f14ef",
  null
  
)

export default component.exports